export default "__VITE_ASSET__792733d6__"